var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.newMenus,"default-checked-keys":_vm.defaultCheckedKeys,"node-key":"menu_id","props":_vm.defaultProps,"show-checkbox":"","default-expand-all":_vm.expandAll}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }